module.exports = __webpack_public_path__ + "static/media/gametag.337fba8f.png";